import { BASE_COLOURS } from '~config/colours';
import type { BaseColour, ColourByParameter } from '~types';

type ParameterColourConfig = {
  value: ColourByParameter;
  label: string;
  colour: BaseColour;
};

/**
 * Labels for drill hole parameters
 */
const PARAMETERS_LABEL_COLOURS: ParameterColourConfig[] = [
  { value: 'depth', label: 'Depth', colour: BASE_COLOURS.ORANGE },
  { value: 'diameter', label: 'Diameter', colour: BASE_COLOURS.GREEN },
  { value: 'burden', label: 'Burden', colour: BASE_COLOURS.BLUE },
  { value: 'spacing', label: 'Spacing', colour: BASE_COLOURS.PURPLE },
  { value: 'bearing', label: 'Bearing', colour: BASE_COLOURS.RED },
  { value: 'dip', label: 'Dip', colour: BASE_COLOURS.TEAL },
  { value: 'blast_mj', label: 'Blast Energy', colour: BASE_COLOURS.YELLOW },
  { value: 'crush_mj', label: 'Crush Energy', colour: BASE_COLOURS.PINK },
  { value: 'dig_mj', label: 'Dig Energy', colour: BASE_COLOURS.BROWN },
  { value: 'drill_mj', label: 'Drill Energy', colour: BASE_COLOURS.GREY },
];

/**
 * Default values for drill hole properties
 */
const DRILL_HOLE_DEFAULTS = {
  DIAMETER: 0.165, // meters
  DEPTH: 10, // meters
  BURDEN: 4, // meters
  SPACING: 4.6, // meters
  BEARING: 0, // degrees
  DIP: 90, // degrees
  BLAST_MJ: 0,
  CRUSH_MJ: 0,
} as const;

export { DRILL_HOLE_DEFAULTS, PARAMETERS_LABEL_COLOURS };
